import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const Navigation = ({
	data,
	announcementsData,
}) => (
	<ul className="navigation">
		{data ? (
			data.map((page, index) => (
				// eslint-disable-next-line react/no-array-index-key
				<li key={index}>
					<Link to={page.url}>{page.name}</Link>
					{page.name === 'Latest News' && announcementsData?.length > 0 && (
						<div className="navigation__badge" />
					)}
				</li>
			))) : null}
	</ul>
);

export default Navigation;

Navigation.propTypes = {
	data: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		url: PropTypes.string,
		showBadge: PropTypes.bool,
	})).isRequired,
	announcementsData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
